import { connect } from 'react-redux';
import TagsNewsComponent from '../components/TagsNewsComponent';
import { getAllTagsIfNeeded } from '../actions/NewsActions';

const mapStateToProps = (state) => ({
    dataTags: state.news.dataTags,
});

const mapDispatchToProps = (dispatch) => ({
    getAllTags: () => {
        dispatch(getAllTagsIfNeeded());
    },
});

const TagsNewsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TagsNewsComponent);

export default TagsNewsContainer;
